import React, {useContext} from "react";
import {MyAppContext} from "../ui/AppContext";
import {useNavigate} from "react-router-dom";

const useStateNavigation = () => {
    const { navStore, setNavStore } = useContext(MyAppContext);
    const nav = useNavigate();

    const deleteHashHistory = (path: string) => {
        setNavStore(prev => {
            if (path in prev.hashHistory) {
                delete prev.hashHistory[path];
            }
            return prev;
        });
    }

    return {
        deleteHashHistory
    }
}

export default useStateNavigation;